"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with menu objects
 */
class MenusApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/menus';
    }
    /**
     * Get pages includes in menu by marker.
     *
     * @param {string} [marker] - Menu marker
     *
     * @returns Returns a single menu object as a ContentMenu object with included pages
     */
    async getMenusByMarker(marker) {
        const result = await this._fetchGet(`/marker/${marker}`);
        const pages = result.pages;
        pages.forEach(page => {
            const children = pages.filter(child => child.parentId === page.id);
            if (children.length) {
                page.children = children;
            }
        });
        return result;
    }
}
exports.default = MenusApi;
